import { styled } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import navLogo from '../../assets/images/logo.png';

const StyledAppBar = styled(AppBar)({
  backgroundColor: '#F8F9FA',
});

export default function Navbar() {
  return (
    <Box sx={{ display: 'flex', marginBottom: 15 }}>
      <CssBaseline />
      <StyledAppBar position="fixed">
        <Toolbar>
          <img src={navLogo} alt="Luxie tech" height="30" />
        </Toolbar>
      </StyledAppBar>
    </Box>
  );
}
